import { render, staticRenderFns } from "./PrivacyPolicyText.vue?vue&type=template&id=2c2708ea&scoped=true"
import script from "./PrivacyPolicyText.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyText.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyText.vue?vue&type=style&index=0&id=2c2708ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2708ea",
  null
  
)

export default component.exports